/* eslint-disable no-console */
/* eslint-disable global-require */
import React from "react";

import "@/core/array";
import "@/core/yup";
import "./i18n";
import log from "loglevel";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import config, { Config } from "./config";
import * as globalLogger from "./globalLogger";
import { mobileIntegration } from "./integration";
import { Providers } from "./providers";
import { userApi } from "./shared/apis";
import { IDENTITY_STORAGE_KEY, parseIdentity, tokenProvider } from "./shared/hooks";
import GlobalStyle from "./styles/globalStyle";

function startup(theConfig: Config) {
    // initialize exception logger
    // do this so early as possible
    globalLogger.init();

    // Setup logger & dump config
    log.setLevel(theConfig.LOG_LEVEL, false);
    console.log("version.semanticVersion:", theConfig.BUILD.VERSION);
    log.info("config", JSON.stringify(theConfig, null, 3));

    const root = createRoot(document.getElementById("root"));
    root.render(
        <BrowserRouter>
            <GlobalStyle />
            <Providers>
                <App />
            </Providers>
        </BrowserRouter>,
    );
}

function waitForToken(finalConfig: Config): Promise<Config> {
    const identity = sessionStorage.getItem(IDENTITY_STORAGE_KEY);

    if (!mobileIntegration.isNativeApp() || identity) {
        return Promise.resolve(finalConfig);
    }

    return new Promise((resolve) => {
        mobileIntegration.postMessage("startLoading");
        const div = document.createElement("h2");
        div.appendChild(document.createTextNode("Waiting for token..."));
        document.body.appendChild(div);

        // eslint-disable-next-line func-names
        window.fragmentedAccess = async function (accessToken: string) {
            const accessRights = await userApi.getAccessRights(accessToken);
            // Store token ASAP
            tokenProvider.setToken(accessToken);

            const newIdentity = parseIdentity(accessToken, accessRights, null);

            // Session storage
            sessionStorage.setItem(IDENTITY_STORAGE_KEY, JSON.stringify(newIdentity));

            // Local storage
            localStorage.setItem("consentCategories", "strict");

            // remove text element
            document.body.removeChild(div);
            mobileIntegration.postMessage("stopLoading");

            // success
            resolve(finalConfig);
        };

        mobileIntegration.postMessage("token");
    });
}

waitForToken(config)
    .then((finalConfig) => {
        startup(finalConfig);
    })
    .catch((error) => {
        // can't load the cfg
        // fallback to default config
        console.error("Failed to load config: ", error.message);
        startup(config);
    });
